import { React, useState, useEffect, createContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import { GetKey, GetText } from "../../../../Helpers/GetKey";
import { ValOnlyNumber } from "../../../../Validators/ValOnlyNumber";
import { Moneda } from "../../../../Helpers/Moneda";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { FormatMoney } from "../../../../Helpers/FormatNumber";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FeaturedPlayList } from "@mui/icons-material";
import PercentIcon from '@mui/icons-material/Percent';
import PlantillaScreen from "../../../helpers/PlantillaScreen";

const GenerarConvenioModal = ({ open, onClose, facturasSeleccionadas, saldo, moratorios, total, mediocontacto, gestion, objecion, comentario_gestion, categoria, responsable, idcliente }) => {
  const [tipo, setTipo] = useState("");
  const [contacto, setContacto] = useState({ medio: null });
  const [responsablesCobranza, setResponsablesCobranza] = useState([]);
  const { state } = useLocation();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [info, setInfo] = useState({
    info: {},
    revolvente: {},
    operacion: {},
  });

  const fechaHoy = new Date();
  const dia = String(fechaHoy.getDate()).padStart(2, '0');
  const mes = String(fechaHoy.getMonth() + 1).padStart(2, '0'); // Los meses son 0-indexados
  const anio = fechaHoy.getFullYear();
  const fechaFormateada = `${anio}-${mes}-${dia}`;

  const [convenioPago, setConvenioPago] = useState({
    monto: 0,
    fechaconvenio: fechaFormateada,
    notificacion: false,
    fechanotificacion: "",
    mediocontacto: "T",
    descuento: 0,
    razon_descuento: "",
    responsable: "",
    idresponsable: responsable,
    ADR: 0,
    firma: state.razonsocial,
    bmonto: false,
  });


  const [calculoFacturas, setCalculoFacturas] = useState({
    saldo: 0,
    pactados: 0,
    moratorios: 0,
    total: 0
  });

  const [sumaFacturas, setSumaFacturas] = useState({
    saldo: 0,
    moratorios: 0,
    pactados: 0,
    total: 0
  });

  useEffect(() => {
    const interes = facturasSeleccionadas.map(factura => {
      // Parsear las fechas de convenio y vencimiento
      const [anioConvenio, mesConvenio, diaConvenio] = convenioPago.fechaconvenio.split('-');
      const [mesVencimiento, diaVencimiento, anioVencimiento] = factura.vencimiento.split('/');

      // Crear objetos Date utilizando el formato 'yyyy/mm/dd'
      const fechaConvenio = new Date(`${anioConvenio}/${mesConvenio}/${diaConvenio}`);
      const fechaVencimiento = new Date(`${anioVencimiento}/${diaVencimiento}/${mesVencimiento}`);

      // Calcular la diferencia en días
      const diffTime = fechaConvenio - fechaVencimiento;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // Multiplicar la diferencia en días por el saldo de la factura}

      let saldoMultiplicado

      if (factura.tasa != 55.68) {
        saldoMultiplicado = (diffDays * factura.saldo * (factura.tasa * 2)) / 100 / 360;
      }
      else {
        saldoMultiplicado = (diffDays * factura.saldo * factura.tasa) / 100 / 360;
      }

      if (saldoMultiplicado < 0) {
        saldoMultiplicado = 0
      }

      return saldoMultiplicado;
    });

    const interespactado = facturasSeleccionadas.reduce((total, factura) => {
      if (factura.interespactado > 0) {
        return total + factura.interespactado;
      }
      return total;
    }, 0);


    const subinteres = interes.reduce((total, interes) => total + interes, 0);
    const totalinteres = parseFloat(subinteres) + parseFloat(interespactado);
    const interesesTotal = (100 - convenioPago.descuento) / 100 * totalinteres
    const interesesTotalRedondeado = parseFloat(interesesTotal.toFixed(2));

    const sumaSaldo = facturasSeleccionadas.reduce((total, factura) => total + factura.saldo, 0);

    const total = interesesTotalRedondeado + sumaSaldo
    const totalRedondeado = parseFloat(total.toFixed(2));

    setCalculoFacturas({
      ...calculoFacturas,
      saldo: sumaSaldo,
      pactados: interespactado,
      moratorios: subinteres,
      total: totalRedondeado,
    });

    if (convenioPago.monto > totalRedondeado) {
      onChange("monto", totalRedondeado.toString(), true, "");
    }

  }, [facturasSeleccionadas, convenioPago.fechaconvenio, convenioPago.descuento])

  const onChange = (prop, value, sbool, smensaje) => {
    const sinComas = value.replace(/,/g, "");
    const facturas = parseFloat(calculoFacturas.total)

    if (sinComas > facturas) {
      document.getElementById("monto").value = FormatMoney(
        facturas
      );
    }
    setConvenioPago({
      ...convenioPago,
      [prop]: facturas > sinComas ? sinComas : facturas,
      ["b" + prop]: false,
      ["m" + prop]: "",
    });
  };

  useEffect(() => {
    if (convenioPago.monto && open) {
      document.getElementById("monto").value = FormatMoney(
        convenioPago.monto
      );
    }
  }, [calculoFacturas.total]);



  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`Infoclientes/informacion?idcliente=${Number(state.idcliente)}`)
      .then(({ info, revolvente, operacion }) => {
        setLoader({ ...loader, mostrar: false });
        setInfo({
          info,
          revolvente,
          operacion,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
      });
  }, []);

  useEffect(() => {
    if (mediocontacto) {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`MostarContactoCliente/ContactoCliente?idcliente=${idcliente}&medio=${mediocontacto}`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          if (Array.isArray(result) && result.length > 0) {
            setContacto(result[0]);
          } else {
            setContacto({ medio: "No tiene el medio seleccionado registrado" });
          }
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
        });
    }
  }, [mediocontacto]);

  useEffect(() => {
    request
      .get("GenerarConvenioModal/DropDownListResponsables")
      .then((result) => {
        setResponsablesCobranza(result);
        if (responsable) {
          const selectedResponsable = result.find(
            (cob) => cob.idusuario === responsable
          );
          if (selectedResponsable) {
            setConvenioPago((prevComentarios) => ({
              ...prevComentarios,
              idresponsable: selectedResponsable.idusuario,
              responsable: selectedResponsable.responsable_cobranza,
              ADR: selectedResponsable.adr,
            }));
          }
        }
      })
      .catch((error) => {
        Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
      });
  }, [responsable]);

  const imprimirConvenio = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio: "*************",
      idcliente: state.idcliente,
      razon_social: info.info.razon_social,
      referencia: info.info.referencia,
      adr: convenioPago.ADR,
      monto: convenioPago.monto,
      tipo_credito: tipo,
      fecha_convenio: new Date(),
      recordatorio: convenioPago.notificacion,
      fecha_recordatorio: convenioPago.fechanotificacion,
      mediocontacto: mediocontacto,
      nombre_usuario: convenioPago.responsable.toUpperCase(),
      firma: convenioPago.firma,
      detalle: JSON.stringify(facturasSeleccionadas),
      gestion: gestion,
      comentarios: "",
      volvercontactar: 0,
      fechavolveracontactar: "",
      saldo: 0,
      moratorios: 0,
      interespactado: 0,
      total: 0
    };
    request
      .post(`ConvenioPago/ReporteConvenioPDF`, post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        await Swal.fire({
          title: "CONVENIO DE PAGO",
          text: "Impresion",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
        // history.push("/Creditoycobranza/ConvenioPago");
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });

  };

  const guardarConvenio = () => {
    if (facturasSeleccionadas.length === 0) {
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "Debes seleccionar al menos una factura.",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }
    if (convenioPago.responsable === 0 || convenioPago.responsable === null || convenioPago.responsable === "") {
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "Selecciona un responsable.",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return; // Detiene la ejecución si no hay facturas seleccionadas
    }
    if (convenioPago.firma === 0 || convenioPago.firma === null || convenioPago.firma === "") {
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "Se necesita el nombre del cliente que firma",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return; // Detiene la ejecución si no hay facturas seleccionadas
    }
    if (convenioPago.mediocontacto === "DO") {
      imprimirConvenio();
      return;
    }

    if (convenioPago.monto <= 0 || convenioPago.monto === null || convenioPago.monto === "") {
      setLoader({ ...loader, mostrar: false });
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "El monto a pagar debe de ser mayor a 0",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return; // Detiene la ejecución si no hay facturas seleccionadas
    }

    if (convenioPago.fechanotificacion > convenioPago.fechaconvenio) {
      setLoader({ ...loader, mostrar: false });
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "La fecha del recordatorio no debe ser mayor a la fecha de compromiso de pago",
        icon: "error",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio: "*************",
      idcliente: state.idcliente,
      razon_social: info.info.razon_social,
      referencia: info.info.referencia,
      adr: convenioPago.ADR,
      monto: convenioPago.monto,
      tipo_credito: tipo,
      fecha_convenio: convenioPago.fechaconvenio,
      recordatorio: convenioPago.notificacion,
      fecha_recordatorio: convenioPago.fechanotificacion,
      mediocontacto: mediocontacto,
      nombre_usuario: convenioPago.responsable.toUpperCase(),
      idresponsable: convenioPago.idresponsable,
      firma: convenioPago.firma,
      descuento: convenioPago.descuento,
      razon_descuento: convenioPago.razon_descuento,
      detalle: JSON.stringify(facturasSeleccionadas),
      gestion: gestion,
      comentario_gestion: comentario_gestion,
      categoria: categoria,
      objecion: objecion,
      comentarios: "",
      volvercontactar: 0,
      fechavolveracontactar: "",
      saldo: 0,
      moratorios: 0,
      interespactado: 0,
      total: 0
    };
    const postresponsable = {
      idcliente: idcliente,
      idusuario: convenioPago.idresponsable
    };
    request
      .post(`GenerarConvenioModal/Guardar`, post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        await Swal.fire({
          title: "CONVENIO DE PAGO",
          text: "Registro guardado con éxito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
        onClose();
      })
      .then(async (result) => {
        return request.post(`ClientesResponsableCobranza/Guardar`, postresponsable);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  };

  return (
    <>
      <LoaderScreen loader={loader} />
      <Modal open={open} onClose={onClose}>
        <div className="generar-convenio-modal-formulario">
          <div className="generar-convenio-modal-plantilla">
            <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
              <PlantillaScreen
                titulo={state.razonsocial}
                className_main={1}
                className={"plantilla-screen-filtro-container-modal"}
              >
                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                <div className={`generar-convenio-modal-agregar-convenio`}>
                  <div className="generar-convenio-modal-agregar-convenio-container scroll-4">
                    <h3 className="titulo-seccion">Generar Convenio</h3>
                    <TextField
                      id="contacto"
                      size="small"
                      label="Contacto"
                      variant="outlined"
                      type="text"
                      inputProps={{
                        style: { textAlign: "left" },
                        readOnly: true,
                      }}
                      value={contacto.medio || ""}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      id="monto"
                      size="small"
                      label="Monto a Pagar"
                      name="monto"
                      variant="outlined"
                      type="text"
                      inputProps={{
                        style: { textAlign: "right" },
                      }}
                      // disabled={convenioPago.mediocontacto === "DO" ? true : false}
                      onKeyUp={(input) => Moneda(input.target)}
                      // value={convenioPago.monto}
                      onChange={({ target }) => {
                        ValOnlyNumber("monto", target.value, onChange, true, 30);
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                      sx={{ mt: 2 }}
                    />

                    <TextField
                      size="small"
                      type="date"
                      label="Fecha Convenio"
                      value={convenioPago.fechaconvenio}
                      onChange={(e) => {
                        setConvenioPago({
                          ...convenioPago,
                          fechaconvenio: e.target.value
                        });
                      }}
                      sx={{ mt: 2 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                    />

                    <TextField
                      className="input-medio-comunicacion"
                      fullWidth
                      size="small"
                      label="Responsable"
                      select
                      type="text"
                      value={convenioPago.idresponsable || ""}
                      onChange={(e) => {
                        const selectedResponsable = responsablesCobranza.find(
                          (cob) => cob.idusuario === e.target.value
                        );
                        setConvenioPago({
                          ...convenioPago,
                          responsable: selectedResponsable?.responsable_cobranza || "",
                          ADR: selectedResponsable?.adr || 0,
                          idresponsable: selectedResponsable?.idusuario || 0,
                        });
                      }}
                      sx={{ mt: 2 }}
                    >
                      {responsablesCobranza.map((cob) => (
                        <MenuItem key={cob.idusuario} value={cob.idusuario}>
                          {cob.responsable_cobranza}
                        </MenuItem>
                      ))}
                    </TextField>

                    <TextField
                      id="firma"
                      size="small"
                      label="Cliente que Firma"
                      variant="outlined"
                      type="text"
                      inputProps={{
                        style: { textAlign: "left" },
                      }}
                      // disabled={convenioPago.mediocontacto === "DO" ? true : false}
                      value={convenioPago.firma}
                      onChange={({ target }) => {
                        setConvenioPago({ ...convenioPago, firma: target.value.toUpperCase() });
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                      sx={{ mt: 2 }}
                    />

                    {convenioPago.mediocontacto !== "DO" && (
                      <div className="generar-convenio-modal-agregar-datos-columna-2">
                        <div className="generar-convenio-modal-agregar-recordatorio">
                          <input
                            type="checkbox"
                            name="convenio"
                            className="chk-groups"
                            id="convenio"
                            checked={convenioPago.notificacion}
                            onChange={(e) => {
                              setConvenioPago({
                                ...convenioPago,
                                notificacion: e.target.checked,
                              });
                            }}
                          />
                          <span>Recordatorio</span>
                        </div>
                        {convenioPago.notificacion && (
                          <div>
                            <TextField
                              disabled={!convenioPago.notificacion}
                              size="small"
                              type="date"
                              fullWidth
                              onChange={(e) => {
                                setConvenioPago({
                                  ...convenioPago,
                                  fechanotificacion: e.target.value,
                                });
                              }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                    <div className="generar-convenio-modal-calculo-totales">
                      <TextField
                        id="total"
                        size="small"
                        label="Saldo"
                        variant="outlined"
                        type="text"
                        inputProps={{
                          style: { textAlign: "right" },
                          readOnly: true,
                        }}
                        value={FormatMoney(calculoFacturas.saldo)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start"></InputAdornment>
                          ),
                        }}
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        id="total"
                        size="small"
                        label="Pactados"
                        variant="outlined"
                        type="text"
                        inputProps={{
                          style: { textAlign: "right" },
                          readOnly: true,
                        }}
                        value={FormatMoney(calculoFacturas.pactados)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start"></InputAdornment>
                          ),
                        }}
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        id="total"
                        size="small"
                        label="Moratorios"
                        variant="outlined"
                        type="text"
                        inputProps={{
                          style: { textAlign: "right" },
                          readOnly: true, // Esto deshabilita la edición pero mantiene el estilo normal
                        }}
                        value={FormatMoney(calculoFacturas.moratorios)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start"></InputAdornment>
                          ),
                        }}
                        sx={{ mt: 2 }}
                      />
                      <TextField
                        id="total"
                        size="small"
                        label="Total"
                        variant="outlined"
                        type="text"
                        inputProps={{
                          style: { textAlign: "right" },
                          readOnly: true,
                        }}
                        value={FormatMoney(calculoFacturas.total)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start"></InputAdornment>
                          ),
                        }}
                        sx={{ mt: 2 }}
                      />
                    </div>

                  </div>
                  <div className="generar-convenio-modal-buttons">
                    {/* <div
                                        className="detalle-clientes-gestionar-footer-back"
                                        onClick={() =>
                                            onclose
                                        }
                                    >
                                        <ArrowBackIcon /> Regresar
                                    </div> */}
                    <button
                      className="generar-convenio-modal-button-guardar"
                      onClick={() => guardarConvenio()}
                    >
                      Generar
                    </button>
                  </div>
                </div>
              </PlantillaScreen>
            </div>

          </div>
        </div>
      </Modal >
    </>
  );
};

export default GenerarConvenioModal;


{/* <TextField
                                            id="monto"
                                            size="small"
                                            label="Descuento"
                                            variant="outlined"
                                            type="text"
                                            inputProps={{
                                                style: { textAlign: "right" },
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <PercentIcon className="generar-convenio-modal-icono-input-porcentaje" />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            disabled={convenioPago.mediocontacto === "DO" ? true : false}
                                            onKeyUp={(input) => Moneda(input.target)}
                                            value={convenioPago.descuento}

                                            onChange={({ target }) => {
                                                // Validación del descuento máximo
                                                const descuento = parseFloat(target.value);
                                                if (descuento > 30) {
                                                    // Mostrar mensaje de alerta
                                                    Swal.fire({
                                                        title: "Descuento máximo alcanzado",
                                                        text: "El máximo descuento permitido es del 30%.",
                                                        icon: "warning",
                                                        customClass: {
                                                            container: "mi-superpoop",
                                                        },
                                                    });
                                                    setConvenioPago({ ...convenioPago, descuento: 0 });
                                                } else {
                                                    setConvenioPago({ ...convenioPago, descuento: descuento });
                                                }
                                            }}
                                            sx={{ mt: 2 }}
                                        />

                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Razón de Descuento"
                                            disabled={convenioPago.mediocontacto === "DO" ? true : false}
                                            multiline
                                            rows={1}
                                            sx={{ mt: 2 }}

                                            onChange={(e) => {
                                                setConvenioPago({
                                                    ...convenioPago,
                                                    razon_descuento: e.target.value
                                                });
                                            }}
                                        /> */}